import { render, staticRenderFns } from "./ForcePasswordReset.vue?vue&type=template&id=72312f1c&"
import script from "./ForcePasswordReset.vue?vue&type=script&lang=js&"
export * from "./ForcePasswordReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports